export default __webpack_public_path__ + "static/media/ic-abstract-02.297da22b.svg";